import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { Store, LockOpen, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBusiness } from '../context/BusinessContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const { businessInfo } = useBusiness();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);
    
    if (result.success) {
      // Redirigir según el rol del usuario
      const userRole = result.data?.user?.role;
      if (userRole === 'cliente') {
        navigate('/catalog-client');
      } else {
        navigate('/dashboard');
      }
    } else {
      setError(result.message);
    }
    
    setLoading(false);
  };

  return (
    <Box
      className="d-flex justify-center align-center"
      sx={{
        minHeight: '100vh',
        bgcolor: 'grey.50'
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={3} className="p-xl">
          <Box className="d-flex flex-column align-center mb-lg">
            <Store sx={{ fontSize: 60, color: 'var(--primary-color)', mb: 2 }} />
            <Typography variant="h4" component="h1" className="font-bold text-center">
              {businessInfo?.businessName || process.env.REACT_APP_SITE_NAME || 'Descorcha2'}
            </Typography>
            <Typography variant="body2" color="text.secondary" className="text-center mt-sm">
              Ingresa tus credenciales para acceder
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" className="mb-md">
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Usuario"
              variant="outlined"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
              autoFocus
              autoComplete="username"
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Contraseña"
              type="password"
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              autoComplete="current-password"
              sx={{ mb: 2 }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : <LockOpen />}
              sx={{ mt: 3 }}
            >
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </Button>
          </form>

          <Button
            fullWidth
            variant="outlined"
            size="large"
            onClick={() => navigate('/')}
            startIcon={<Home />}
            sx={{ mt: 2 }}
            disabled={loading}
          >
            Volver al Inicio
          </Button>

          <Box className="mt-lg text-center">
            <Typography variant="caption" color="text.secondary">
              Sistema de Punto de Venta v1.0
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Login;


